<template>
	<v-container class="login-container">
		<!-- 로그인 화면 로고 -->
		<v-layout class="login-layout" wrap justify-center>
			<!-- <v-flex xs12 style="margin-bottom:80px; margin-top:100px;">
				<div class="text-center"></div>
			</v-flex> -->
			<!-- CDP -->

			<v-layout class="login_background" flex-wrap justify-center>
				<v-flex xs12>
					<div style="max-width:600px; margin:0 auto;">
						<div class="title mt-4">
							거점홍보 잠재고객 평가 시스템
						</div>
						<div class="text-center mt-4 px-4">
							<!-- 아이디 -->
							<v-text-field
								:error-messages="iderrorMessages"
								:autofocus="false"
								label="아이디"
								maxlength="255"
								height="50px"
								outlined
								:hideDetails="iderrorMessages === '' ? true : false"
								flat
								v-model="userid"
								@keydown.enter="login()"
								autocomplete="off"
								:class="iderrorMessages === '' ? 'mb-4' : ''"
							></v-text-field>
							<!-- 비밀번호 -->
							<v-text-field
								:error-messages="pwerrorMessages"
								:autofocus="false"
								label="비밀번호"
								type="password"
								height="50px"
								outlined
								:hideDetails="pwerrorMessages === '' ? true : false"
								maxlength="255"
								v-model="password"
								@keydown.enter="login()"
								autocomplete="off"
								:class="pwerrorMessages === '' ? 'mb-4' : ''"
							></v-text-field>
							<!-- <v-checkbox v-model="rememberId" color="MainColor1" :label="`아이디 저장`" class="mt-0 pt-0" hideDetails></v-checkbox> -->
							<v-btn class="loginButton mt-4 mb-12" block elevation="0" @click="login()" color="primary">
								<span style="color:white;	font-weight: bold;">
									로그인
								</span>
							</v-btn>
							<!-- <p class="footer-text">Don't have an account? <span class="signup-text" @click="toSignup">Sign Up</span></p> -->
						</div>
					</div>
				</v-flex>
			</v-layout>
			<!-- 하단 -->
		</v-layout>
	</v-container>
</template>

<script>
export default {
	data() {
		return {
			rememberId: false,
			alertModal2: {
				dialog: false,
				text: '',
			},
			// 아이디 에러메세지
			iderrorMessages: '',
			// 패스워드 에러메세지
			pwerrorMessages: '',
			// id,password 데이터
			userid: '',
			password: '',
			reservedayData: {},
		}
	},
	created() {
		localStorage.removeItem('reserver')
		if (localStorage.getItem('gs-loginId')) {
			this.userid = localStorage.getItem('gs-loginId')
			this.rememberId = true
		}
	},
	methods: {
		login() {
			if (!this.userid) {
				this.iderrorMessages = 'Please enter your ID.'
				return
			} else if (!this.password) {
				this.pwerrorMessages = 'Please enter your PASSWORD.'
				return
			} else {
				const data = {
					code: this.$route.params.code,
					qrCode: this.$route.params.qrcode,
					reserveId: this.userid,
					password: this.password,
				}
				this.$store
					.dispatch('reserveLoginAPI', data)
					.then(res => {
						if (!res.data.reserveLoginAPI.result.secret) {
							this.iderrorMessages = 'Your ID or Password is incorrect.'
							this.pwerrorMessages = 'Your ID or Password is incorrect.'
						} else {
							localStorage.setItem('reserver', res.data.reserveLoginAPI.result.secret + ',' + res.data.reserveLoginAPI.result.created_at)
							this.$router
								.push({ name: 'reserve_page', params: { code: this.$route.params.code, qrcode: this.$route.params.qrcode } })
								.catch(() => {})
						}
					})
					.catch(() => {
						this.iderrorMessages = 'Your ID or Password is incorrect.'
						this.pwerrorMessages = 'Your ID or Password is incorrect.'
					})
					.catch(() => {})
			}
		},
	},
}
</script>
<style lang="scss"></style>
